import { useId, useRef, useState } from 'react';
import { companyPath } from '../utils/company';

export default function ShareJob({ slug, title }: { slug: string; title: string }) {
  const dialog = useRef<HTMLDialogElement>(null);
  const input = useRef<HTMLInputElement>(null);
  const id = useId();
  const [copied, setCopied] = useState(false);
  // Share the public canonical route; never forward query parameters or fragments.
  const url = new URL(companyPath(`job/${encodeURIComponent(slug)}`), window.location.origin).href;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
    } catch {
      input.current?.focus();
      input.current?.select();
    }
  };
  const share = async () => {
    setCopied(false);
    if (navigator.share) {
      try { await navigator.share({ title, url }); return; }
      catch (error) { if (error instanceof Error && error.name === 'AbortError') return; }
    }
    dialog.current?.showModal();
  };
  return <>
    <button type="button" className="career-share-button" onClick={share}>Stelle teilen <span aria-hidden="true">↗</span></button>
    <dialog ref={dialog} className="career-share-dialog" aria-labelledby={`${id}-title`} onClick={event => { if (event.target === event.currentTarget) dialog.current?.close(); }}>
      <div><h2 id={`${id}-title`}>Stelle teilen</h2><button type="button" aria-label="Teilen schließen" onClick={() => dialog.current?.close()}>×</button></div>
      <label htmlFor={`${id}-url`}>Link zur Stelle</label><input ref={input} id={`${id}-url`} value={url} readOnly onFocus={event => event.target.select()} />
      <button type="button" className="career-button" onClick={copy}>{copied ? 'Link kopiert' : 'Link kopieren'}</button>
      <p role="status">{copied ? 'Du kannst den Link jetzt teilen.' : 'Du kannst den Link auch auswählen und kopieren.'}</p>
    </dialog>
  </>;
}
